import Vue from 'vue'
import Vuex from 'vuex'
import timeModule from '../stores/modules/time-module'
import axios from "axios";
import stockmodule from "@/stores/modules/stockmodule";
import grvModule from '../stores/modules/grv-module'
//vuex persist test
import VuexPersistence from 'vuex-persist'
import { set, get, del } from 'idb-keyval'

const indexedDBStorage = {
    getItem: async (key) => await get(key), // Retrieve data from IndexedDB
    setItem: async (key, value) => await set(key, value), // Save data to IndexedDB
    removeItem: async (key) => await del(key), // Remove data from IndexedDB
};
Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
    storage: indexedDBStorage, // Use IndexedDB
});

export default new Vuex.Store({
    state: {
        version: '',
        loading: false,
        Apikey: '',
        branches: [],
    },
    getters: {
        getVersion: (state) => state.version,
        getBranches: (state) => state.branches || JSON.parse(localStorage.getItem('Branches')),
        getLoadingState: (state) => state.loading,
        /**
         * Get the Api-key in decoded/plain form.
         * Prefers the encoded value in localStorage; falls back to state.Apikey if present.
         * - If the candidate does not look base64-like, treat it as already plain and return as string.
         * - Otherwise, attempt up to 18× base64 decode, stopping early if intermediate stops being base64-ish.
         * - Filters junk values and returns an empty string on any error.
         * @param state
         * @returns {string}
         */
        getApikey: (state) => {
            const stored = localStorage.getItem('Api-Key');
            let candidate = (typeof stored === 'string' && stored) ? stored : state.Apikey;

            if (!candidate || candidate === '[object Object]') return '';

            try {
                // If it doesn’t look like base64, assume it’s already plain (covers raw state value cases)
                const b64re = /^[A-Za-z0-9+/=]+$/;
                if (!b64re.test(String(candidate))) {
                    return String(candidate);
                }

                let k = String(candidate);
                for (let i = 0; i < 18; i++) {
                    k = window.atob(k);
                    if (!b64re.test(k)) break; // stop early if next step isn’t base64-ish
                }
                if (!k || k === '[object Object]') return '';
                return k;
            } catch (e) {
                return '';
            }
        },

    },
    mutations: {
        setVersion: (state, data) => {
            state.version = data
        },
        setBranches: (state, data) => state.branches = data,
        setLoadingState: (state, payload) => state.loading = payload,
        /**
         * Store the plain (decoded) API key in Vuex state for easy access.
         * This complements the 18×-encoded value persisted in localStorage under 'Api-Key'.
         * @param state
         * @param {string} key
         */
        setApiKey: (state, key) => {
            state.Apikey = key ? String(key) : '';
        },
    },
    actions: {
        getVersion(context) {
            return axios.get(`${SmartInvoiceApi}auth/version`)
                .then(({data}) => {
                    context.commit('setVersion', data.version)
                })
        },
        editUser: (context,payload) => {
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-Key': Apikey } : {};
            return axios.put(`${portalApi}users/${payload.id}`,payload,{headers})
                .catch(err=>errorHandler.tomcatError(err));
        },
        createUser: (context,payload) => {
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-Key': Apikey } : {};
            const body = Apikey ? { ...payload, apiKey: Apikey } : payload; // include Api‑Key in payload as well
            return context.dispatch(`sendRequest`,{
                url : `${portalApi}users/create`,
                payload: body,
                headers
            })
        },
        triggerResetPassword: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${portalApi}users/resetPassword`,
                payload:{
                    email: payload
                }
            })
        },
        resetPassword: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${portalApi}users/processResetPassword`,
                payload
            })
        },
        createImports: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${portalApi}import/create`,
                payload:{
                    importDto: payload
                }
            })
        },
        getImportsByCode: (context,code) => {
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-Key': Apikey } : {};
            return axios.get(`${SmartInvoiceApi}purchase/getImportByCode?taskCode=${code}`,{headers})
                .then((response) => response.data)
                .catch(err => errorHandler.tomcatError(err));
        },
        getUsers: (context,payload) => {
            return axios.get(`${portalApi}users?email=${payload.email}&contact=${payload.phone}`)
                .then(({data}) => data.response)
                .catch(err => errorHandler.tomcatError(err));
        },
        getProceedImports: (context) => {
            return axios.get(`${portalApi}import/getAll`)
                .then((response) => response.data)
                .catch(err => errorHandler.tomcatError(err));
        },
        downloadProceedImports: (context,response) => {
           return window.open(`${portalApi}import/download?taskDc=${response.taskCd}&dclID=${response.dclID}`)
        },
        getPendingImports: (context) => {
            const Apikey = context.getters.getApikey;
            const headers = Apikey ? { 'Api-Key': Apikey } : {};
            return axios.get(`${SmartInvoiceApi}purchase/getAllImports`,{headers})
                .then((response) => response.data)
                .catch(err => errorHandler.tomcatError(err));
        },
        rePrints: (context, id) => {
            return axios.post(`${LocalServiceApi}printReceipt/${id.localid}?reprint=${id.reprint}`,{})
        },
        getInvoice: (context,payload) => {
            const Apikey = context.getters.getApikey;
            const range = context.getters.getGlobalDateRange;
            const headers = Apikey ? { 'Api-Key': Apikey } : {};
            return axios.get(SmartInvoiceApi+`invoice/search?from=${range.from}&to=${range.to}&auditNumber=${payload.auditNumber}&refund=${payload.refund}&tpin=${payload.tpin}&limit=${payload.limit}`,{headers})
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err));
        },
        // TODO[Online VSDC Login Integration]: 90% — branch IsSmartInitialized for online mode without prompting
        /**
         * Determine SmartInvoice initialization state.
         * - Online VSDC: do not call init/authCheckInitialized. Report presence of stored key only.
         * - Offline/legacy: keep existing initializer endpoint call.
         */
        IsSmartInitialized: async (context) => {
            if (window.isOnlineVsdc) {
                const hasKey = !!localStorage.getItem('Api-Key');
                return { onlineVsdc: true, hasKey };
            }
            return axios.get(`${SmartInvoiceApi}init/authCheckInitialized`).then(({ data }) => data);
        },

        // TODO[Online VSDC Login Integration]: 30% — wire API key into login flow (no popup)
        /**
         * Ensure API key is captured from the Login form (when provided) and verified.
         * Saves key in localStorage encoded 18× to match project convention.
         * @param {Object} context
         * @param {string} [rawApiKey] Plain API key from the login form. Optional if already stored.
         * @returns {Promise<boolean>} true when verified
         */
        // TODO[Api-Key Storage Handling]: 80% — verify first, then persist on success
        ensureApiKeyFromLogin: async (context, rawApiKey) => {
            try {
                const verifyUrl = `${SmartInvoiceApi}auth/verifyApiKey`; // confirm path per resources/api.yaml

                if (!rawApiKey && !localStorage.getItem('Api-Key')) {
                    throw new Error('Missing API key');
                }

                if (rawApiKey) {
                    const plain = rawApiKey.trim();
                    // Pre-set axios default header so the very first request (including login) carries Api-Key
                    try {
                        if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
                            window.axios.defaults.headers.common['Api-Key'] = plain;
                        }
                    } catch (e) { /* no-op */ }

                    // Verify using plaintext header without writing to storage yet
                    const headers = { 'Api-Key': plain };
                    await axios.get(verifyUrl, { headers });

                    // If verification succeeds, encode 18× and persist
                    let encoded = plain;
                    for (let i = 0; i < 18; i++) encoded = window.btoa(encoded);
                    localStorage.setItem('Api-Key', encoded);
                    // Save plain key in Vuex state for easy access
                    context.commit('setApiKey', plain);

                    // Keep axios default header set for subsequent calls
                    try {
                        if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
                            window.axios.defaults.headers.common['Api-Key'] = plain;
                        }
                    } catch (e) { /* no-op */ }

                    Toast.fire({ icon: 'success', title: 'API key verified' });
                    return true;
                }

                // No new key provided — ensure axios default header from stored/decoded key and verify the stored one
                try {
                    const existing = context.getters.getApikey;
                    if (existing) {
                        context.commit('setApiKey', existing);
                        if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
                            window.axios.defaults.headers.common['Api-Key'] = existing;
                        }
                    }
                } catch (e) { /* no-op */ }
                await context.dispatch('verifyApiKeyOnline');
                Toast.fire({ icon: 'success', title: 'API key verified' });
                return true;
            } catch (err) {
                // Clean up invalid key so user is prompted again next time
                localStorage.removeItem('Api-Key');
                try {
                    if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
                        delete window.axios.defaults.headers.common['Api-Key'];
                    }
                } catch (e) { /* no-op */ }
                // Reflect cleanup in Vuex state
                context.commit('setApiKey', '');
                errorHandler.tomcatError(err);
                throw err;
            }
        },

        // TODO[Online VSDC Login Integration]: 60% — confirm verify endpoint path/method from YAML
        /**
         * Verify stored API key with SmartInvoice online endpoint.
         * Uses 18× base64 decode before sending via 'Api-Key' header.
         * Adjust endpoint/method per http://localhost:8282/smartinv/docs/api.yaml if needed.
         * @param {Object} context
         * @returns {Promise<boolean>}
         */
        verifyApiKeyOnline: async (context) => {
            const Apikey = context.getters.getApikey;
            if (!Apikey) throw new Error('Missing API key');
            const headers = { 'Api-Key': Apikey };
            const verifyUrl = `${SmartInvoiceApi}auth/verifyApiKey`;
            try {
                const { status } = await axios.get(verifyUrl, { headers });
                if (status !== 200) throw new Error('API key verification failed');
                // Keep state and axios defaults in sync on success
                context.commit('setApiKey', Apikey);
                try {
                    if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
                        window.axios.defaults.headers.common['Api-Key'] = Apikey;
                    }
                } catch (e) { /* no-op */ }
                return true;
            } catch (err) {
                throw err;
            }
        },

        // TODO[Online VSDC Login Integration]: 80% — login action that incorporates API-key verification in online mode
        /**
         * Submit login, conditionally verifying API key first when in Online VSDC mode.
         * Component should call this action instead of using axios directly.
         * @param {Object} context
         * @param {{email:string, password:string, apiKey?:string}} payload
         */
        submitLogin: async (context, { email, password, apiKey }) => {
            try {
                if (window.isOnlineVsdc) {
                    await context.dispatch('ensureApiKeyFromLogin', apiKey);
                }
                return context.dispatch('sendRequest', {
                    url: `${lytSIApi}users/login`,
                    payload: { email, password },
                });
            } catch (err) {
                throw err;
            }
        },

        // TODO[SmartPortal Login Endpoint]: 30% — add SmartPortal-specific login action per OpenAPI
        /**
         * Authenticate against SmartPortal and start OTP challenge.
         * - Uses `window.portalApi` (e.g., http://localhost:8282/smartportal/)
         * - Sends optional 'Api-Key' header in Online VSDC mode
         * - Body uses { username, password } as per OpenAPI
         * @param {Object} context
         * @param {{email: string, password: string, apiKey?: string}} payload
         * @returns {Promise<{correlationId?: string, status?: string} | any>}
         */
        loginSmartPortal: async (context, { email, password, apiKey }) => {
            try {
                const url = `${portalApi}auth/login`;

                // In Online VSDC mode, ensure Api-key is present/verified and attach it
                const headers = {};
                let k = '';
                if (window.isOnlineVsdc) {
                    if (apiKey) {
                        // Verify and persist freshly entered key first (no write on failure)
                        await context.dispatch('ensureApiKeyFromLogin', apiKey);
                    } else {
                        // If none provided, verify the stored one (throws if missing/invalid)
                        await context.dispatch('verifyApiKeyOnline');
                    }
                    // Attach decoded stored key via getter
                    k = context.getters.getApikey;
                    if (k) {
                        headers['Api-Key'] = k;
                        // Also set axios default so even if headers get lost, interceptor/defaults carry it
                        try {
                            if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
                                window.axios.defaults.headers.common['Api-Key'] = k;
                            }
                        } catch (e) { /* no-op */ }
                    }
                }

                // Include Api‑Key in payload as well when available
                const body = k ? { email, password, apiKey: k } : { email, password };

                // Reuse existing request helper
                const data = await context.dispatch('sendRequest', { url, payload: body, headers });

                // If backend returns correlationId, persist for OTP flow
                const response = data?.response ?? data;
                if (response?.correlationId) {
                    localStorage.setItem('login-correlation-id', response.correlationId);
                }
                return response;
            } catch (err) {
                // Bubble up so the view can show the correct error
                throw err;
            }
        },

        // TODO[SmartPortal OTP Verify]: 30% — add action to attach Api-key and optional correlationId
        /**
         * Verify OTP with SmartPortal.
         * - Uses `window.portalApi` (e.g., http://localhost:8282/smartportal/)
         * - Sends 'Api-Key' header when Online VSDC is enabled (decoded 18× from storage)
         * - Includes correlationId if present (saved during login)
         * @param {Object} context
         * @param {{ otp: string, correlationId?: string }} payload
         * @returns {Promise<any>}
         */
        // TODO[SmartPortal OTP Verify]: 70% — ensure Api-Key is attached via both local headers and axios defaults
        verifyOtpSmartPortal: async (context, { otp, correlationId }) => {
            const url = `${portalApi}auth/verifyOtp`;
            const headers = {};
            let k = '';

            if (window.isOnlineVsdc) {
                // Ensure we have a valid API key before continuing
                await context.dispatch('verifyApiKeyOnline');
                k = context.getters.getApikey;
                if (k) {
                    headers['Api-Key'] = k;
                    // Mirror to axios defaults as extra safety in case per-request headers are lost
                    try {
                        if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
                            window.axios.defaults.headers.common['Api-Key'] = k;
                        }
                    } catch (e) { /* no-op */ }
                }
            }

            // Prefer explicit correlationId, else pick it from localStorage if available
            const savedCor = localStorage.getItem('login-correlation-id');
            const bodyBase = savedCor && !correlationId ? { otp, correlationId: savedCor } : { otp, correlationId };

            // Fall back to just { otp } if correlationId not provided
            if (!bodyBase.correlationId) delete bodyBase.correlationId;

            // Include Api‑Key in payload as well when available
            const body = k ? { ...bodyBase, apiKey: k } : bodyBase;

            return context.dispatch('sendRequest', { url, payload: body, headers });
        },
        setUpBranch: (context,payload) =>{
            return context.dispatch(`sendRequest`,{
                url : `${SmartInvoiceApi}init/register`,
                payload
            });
        },
        smartInitializedSignUp: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${lytSIApi}users/login`,
                payload
            });
        },
        deleteaApiKey: (context) => {
            return axios.delete(`${portalApi}delete-api_key`)
                .catch(err=>errorHandler.tomcatError(err));
        },
        showLatestLogs: (context) => {
            return axios.get(`${portalApi}latest-logs`)
                .then(({data}) => data)
                .catch(err=>errorHandler.tomcatError(err));
        },
        smartInitializedverify: (context,payload) => {
            return context.dispatch(`sendRequest`,{
                url : `${SmartInvoiceApi}init/authAgentVerification`,
                payload
            }).then((response) => {
                localStorage.setItem("Branches",JSON.stringify(response))
                context.commit(`setBranches`,response)
            })
        },
        logout({ commit }) {
            commit('user', null);
            localStorage.removeItem('user');
        },
        sendRequest(context, {url, payload, headers}) {
            const maxRetries = 3;
            let currentRetry = 0;

            // Ensure payload is an object and has a localid
            if (!payload || typeof payload !== 'object') payload = {};
            if (!payload.localid) payload.localid = generateUUID();

            // Enforce Api-key header and apiKey in body for Online VSDC Smart endpoints
            try {
                if (window.isOnlineVsdc) {
                    const k = context.getters.getApikey; // decoded plain key or ''
                    if (k) {
                        // Merge header
                        headers = { ...(headers || {}), 'Api-Key': k };

                        // If posting to SmartPortal/SmartInvoice, ensure apiKey in body too
                        const isPortal = typeof portalApi === 'string' && url.indexOf(portalApi) === 0;
                        const isSmartInv = typeof SmartInvoiceApi === 'string' && url.indexOf(SmartInvoiceApi) === 0;
                        if ((isPortal || isSmartInv) && !('apiKey' in payload)) {
                            payload = { ...payload, apiKey: k };
                        }
                    }
                }
            } catch (e) { /* never block request due to enforcement */ }

            const attemptRequest = () => {
                return axios.post(url, payload, {
                    headers: headers || {}
                }).then(({data}) => {
                    if (!data.processed) {
                        // Check if the response indicates unprocessed data and if retries are available
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Data unprocessed, retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                        // Throw an error if max retries are reached with unprocessed data
                        throw new Error('Data still unprocessed after maximum retries : ' + maxRetries);
                    }
                    context.commit('setLocalid', payload.localid)
                    return data.response; // Return the response if data is processed
                }).catch(err => {
                    if (err && (err.code === 'ECONNABORTED' || (err.message && err.message.includes('timeout')))) {
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                    }
                    throw err; // Re-throw the error if it's not a timeout or retries are exhausted
                });
            };
            return attemptRequest()
                .then(response => response)
                .catch(err => errorHandler.tomcatError(err));
        }
    },
    modules: {timeModule, grvModule, stockmodule},
    plugins: [
        vuexLocal.plugin,
        (store) => {
            // TODO[Api-Key State+Storage Sync]: 70% — bootstrap state.Apikey from storage on app init
            try {
                const existing = store.getters.getApikey;
                if (existing) {
                    store.commit('setApiKey', existing);
                    if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
                        window.axios.defaults.headers.common['Api-Key'] = existing;
                    }
                }
            } catch (e) { /* no-op */ }

            // TODO[Axios Global Api-key Interceptor]: 85% — auto-attach Api-key header in Online VSDC mode
            // Attach a request interceptor to ensure 'Api-Key' is consistently passed on all requests
            axios.interceptors.request.use((config) => {
                try {
                    if (window.isOnlineVsdc) {
                        const k = store.getters.getApikey; // decoded or ''
                        if (k) {
                            if (!config.headers) config.headers = {};
                            config.headers['Api-Key'] = k;
                        }
                    }
                } catch (e) { /* no-op */ }
                return config;
            });
        },
    ],
});

